import styled from 'styled-components';

const ItemContainer = styled.div`
  border-radius: 5px;
  background-color: #ffffff;
  border: 1px solid #ccc4d2;
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  margin-bottom: 20px;
`;

export default ItemContainer;
